/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_Link_CopiedInputs */

const cs_property_list_link_copied = /** @type {(inputs: Property_List_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz zkopírován`)
};

const en_property_list_link_copied = /** @type {(inputs: Property_List_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Property_List_Link_CopiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_link_copied = /** @type {((inputs?: Property_List_Link_CopiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_Link_CopiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_link_copied(inputs)
	return cs_property_list_link_copied(inputs)
});